webpackJsonp([52547762336625],{

/***/ 407:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby Starter - Stellar by HTML5 UP"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---generic-12520c012e8532e9ed07.js